<template>
  <div class="activity-log-container h-100">
    <div class="al-topbar">
      <div class="float-right">
        <b-btn variant="flat" @click="clearUnCompletedTasks" v-b-tooltip.hover title="Clear uncompleted sites" class="delete-btn icon-button">
          <brush-icon class="icon-default brush-icon"></brush-icon>
        </b-btn>
        <b-btn variant="flat" @click="clearAllActivities" v-b-tooltip.hover title="Clear all activities" class="delete-btn icon-button">
          <delete-icon class="icon-default delete-icon"></delete-icon>
        </b-btn>
      </div>
    </div>
    <div class="al-body">

      <b-row class="h-100 w-100">
        <b-col cols="4" class="form-container">
          <div class="">
            <div class="action-label">
              Select Date Range
            </div>
            <div class="action-container">
              <daterange :sync-range.sync="range" :lang="lang" @change="onChange" :emitChangeOnStep0="true" :open-transition="false" month-year-format="MMMM"></daterange>
            </div>
          </div>
          <div class="my-2 w-100 actions-chips-container">
            <div class="action-label">
              Select action
            </div>
            <div class="d-flex flex-wrap chips-container">
              <div class="action-chips" @click="selectAction({value:null})" v-bind:class="{'active':getKeyword===null}">All</div>
              <div class="action-chips" v-for="(action,index) in actions" :key="index" @click="selectAction(action)" v-bind:class="{'active':getKeyword===action.value}">{{action.name}}</div>
            </div>
          </div>
          <div class="my-2">
            <div class="action-label">
              Select user
            </div>
            <div class="d-flex flex-wrap user-container">
              <div class="user-avatar" style="min-width: 37px;" @click="selectUser({userID:null})" v-bind:class="{active:selectedUser===null}">
                <img class="all-user" />
                <span class="all-user-text">all</span>
              </div>
              <div class="user-avatar" v-for="user in users" :key="user.userID" @click="selectUser(user)" v-bind:class="{active:selectedUser===user.userID}">
                <img :src="user.gravURL" />
              </div>
            </div>
          </div>
          <div class="action-footer my-2 text-right">
            <b-btn variant="primary" @click="fetchActivityLog">Show Activity
              <spinner size="small" v-if="buttonLoaders.fetchingActivity"></spinner>
            </b-btn>
          </div>
        </b-col>
        <b-col class="activity-panel-wrapper">
          <div class="activity-panel">
            <activity-log-item v-for="(activity,day) in activities" :key="day" :activities="activity" :day="day" @openSiteResponse="openSiteResponse" @openReportIssue="openReportIssue" @deleteLog="deleteLog" @retryTask="retryTask"></activity-log-item>
            <empty-placeholder v-if="Object.keys(activities).length==0 && !buttonLoaders.fetchingActivity" v-bind="placeholderProps"></empty-placeholder>
            <b-row class="loadmore-wrapper" v-if="this.currentPage < this.totalPages">
              <div class="triangle-placeholder"></div>
              <b-col class="text-center">
                <b-btn variant="primary" class="light" @click="loadMoreData">Load More
                  <spinner size="small" v-if="buttonLoaders.isLoadingMore"></spinner>
                </b-btn>
              </b-col>
            </b-row>
          </div>

        </b-col>

      </b-row>
      <site-response ref="sitereponse" :history="currentHistory"></site-response>
      <report-issue ref="reportissue" :action="currentAction"></report-issue>
      <prompt-popup ref="promptpopup" :action="modalCallback" :args="modalArgs"></prompt-popup>
    </div>
  </div>
</template>

<script>
import ReportIssue from '../modals/ReportIssue';
import SiteResponse from '../modals/SiteResponse';
import PromptPopup from '../modals/PromptPopup';

import DeleteIcon from '../../assets/delete.svg';
import BrushIcon from '../../assets/brush.svg';

import ActivityLogItem from '../ActivityLog/ActivityLogItem';
import Vue from 'Vue';
import { DateRange } from 'vue-date-range';
import _ from 'lodash';
import moment from 'moment';

import EmptyPlaceholder from '../Common/EmptyPlaceholder';
export default {
  name: 'activitylog',
  components: {
    daterange: DateRange,
    ReportIssue,
    EmptyPlaceholder,
    SiteResponse,
    PromptPopup,
    ActivityLogItem,
    DeleteIcon,
    BrushIcon
  },
  mounted() {
    this.fetchActivityLog();
  },
  data() {
    return {
      lang: 'en',
      searchText: '',
      activities: [],
      rawActivities: [],
      users: [],
      selectedUser: null,
      getKeyword: null,
      currentHistory: {},
      currentAction: {},
      actions: [],
      modalCallback: {},
      modalArgs: {},
      lastSuccessfullPayload: {},
      totalPages: 0,
      currentPage: 0,
      buttonLoaders: {
        isLoadingMore: false,
        fetchingActivity: false
      },
      range: {
        startDate: moment().subtract(7, 'days'),
        endDate: moment()
      },
      placeholderProps: {
        text: () => {
          return `Bummer, there are no activites logged in the given search criteria.`;
        },
        type: 'neutral'
      }
    };
  },
  methods: {
    onChange(range) {
      this.range = range;
    },
    dateSelected(value) {},
    selectAction(action) {
      this.getKeyword = action.value;
    },
    selectUser(user) {
      this.selectedUser = user.userID;
    },
    loadMoreData() {
      this.buttonLoaders.isLoadingMore = true;
      let nextPage = this.currentPage + 1;
      if (this.lastSuccessfullPayload) {
        this.lastSuccessfullPayload.requiredData.getHistoryPageHTMLV3.page = nextPage;
        this.$store
          .dispatch('sendAction', this.lastSuccessfullPayload)
          .then(response => {
            this.buttonLoaders.isLoadingMore = false;
            this.rawActivities = this.rawActivities.concat(
              response.data.getHistoryPageHTMLV3.activities
            );
            this.activities = _.groupBy(this.rawActivities, 'activityLabel');
            this.lastSuccessfullPayload = this.lastSuccessfullPayload;
            this.totalPages = response.data.getHistoryPageHTMLV3.totalPages;
            this.users = response.data.getAccessibleUsersV3;
            this.actions = response.data.getActivityCategoriesV3;
            this.currentPage = nextPage;
          });
      }
    },
    fetchActivityLog() {
      let payload = {};
      let selectedSiteIDs = this.$store.getters.selectedSiteIds;
      this.buttonLoaders.fetchingActivity = true;
      
      payload.requiredData = {
        getHistoryPageHTMLV3: {
          siteIDs: selectedSiteIDs,
          dates: {
            fromDate: this.range.startDate.startOf('day').unix(),
            toDate: this.range.endDate.unix()
          }
        },
        getActivityCategoriesV3: 1,
        getAccessibleUsersV3: 1
      };
      if (this.getKeyword) {
        payload.requiredData.getHistoryPageHTMLV3[
          'getKeyword'
        ] = this.getKeyword;
      }
      if (this.selectedUser) {
        payload.requiredData.getHistoryPageHTMLV3['userID'] = this.selectedUser;
        payload.requiredData.getHistoryPageHTMLV3['searchByUser'] = 1;
      }

      this.$store.dispatch('sendAction', payload).then(response => {
        this.rawActivities = response.data.getHistoryPageHTMLV3.activities;
        this.activities = _.groupBy(this.rawActivities, 'activityLabel');
        this.lastSuccessfullPayload = _.cloneDeep(payload);
        this.totalPages = response.data.getHistoryPageHTMLV3.totalPages;
        this.users = response.data.getAccessibleUsersV3;
        this.actions = response.data.getActivityCategoriesV3;
        this.currentPage = 1;
        this.buttonLoaders.fetchingActivity = false;
      });
    },
    openSiteResponse(history, $event) {
      $event.preventDefault();
      this.currentHistory = history;
      this.$refs.sitereponse.$refs.siteresponsemodal.show();
    },
    doRetryTask(history) {
      let payload = {
        requiredData: {
          manualRetryFailedTask: history.historyID
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.fetchActivityLog();
      });
    },
    retryTask(history) {
      this.$root.$emit('bv::hide::popover');
      this.modalCallback = this.doRetryTask;
      this.modalArgs = history;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    doBulkillTasks(action) {
      let payload = {
        requiredData: {
          terminatePendingProcess: {
            actionID: action.actionID
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.fetchActivityLog();
      });
    },
    bulkKillTasks(action) {
      this.$root.$emit('bv::hide::popover');
      this.modalCallback = this.doBulkillTasks;
      this.modalArgs = action;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    clearAllActivities() {
      this.modalCallback = this.doClearAllActivities;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    doClearAllActivities() {
      let payload = {
        requiredData: {
          clearHistoryTasks: {
            dates: {
              fromDate: this.range.startDate.unix(),
              toDate: this.range.endDate.unix()
            },
            clearWhat: 'searchList'
          }
        }
      };
      if (this.selectedUser) {
        payload.requiredData.clearHistoryTasks['userID'] = this.selectedUser;
        payload.requiredData.clearHistoryTasks['searchByUser'] = 1;
      }
      if (this.getKeyword) {
        payload.requiredData.clearHistoryTasks['getKeyword'] = this.getKeyword;
      }
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.fetchActivityLog();
      });
    },
    clearUnCompletedTasks() {
      this.modalCallback = this.doClearUnCompletedTasks;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    doClearUnCompletedTasks() {
      let payload = {
        requiredData: {
          clearHistoryTasks: {
            clearWhat: 'uncomplete'
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.fetchActivityLog();
      });
    },
    openReportIssue(action, $event) {
      $event.stopPropagation();
      $event.preventDefault();

      this.$root.$emit('bv::hide::popover');
      this.currentAction = action;
      this.$refs.reportissue.$refs.reportissuemodal.show();
    },
    doDeleteLog(action) {
      let payload = {
        requiredData: {
          clearHistoryTasks: {
            actionID: action.actionID,
            clearWhat: 'singleAct'
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.fetchActivityLog();
      });
    },
    deleteLog(action, $event) {
      $event.stopPropagation();
      $event.preventDefault();
      this.$root.$emit('bv::hide::popover');
      this.modalCallback = this.doDeleteLog;
      this.modalArgs = action;
      this.$refs.promptpopup.$refs.promptmodal.show();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/ActivityLog.vue